// src/services/api.ts
import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || '/api';

export const getApiErrorMessage = (error: unknown): string => {
  if (axios.isAxiosError(error)) {
    const detail = error.response?.data?.detail;
    if (typeof detail === 'string') return detail;
    if (error.code === 'ECONNABORTED') return 'The scan timed out. Please try again.';
    if (!error.response) return 'The scanner service is currently unavailable.';
  }
  return 'The scan could not be completed. Please try again.';
};

export const api = {
  health: async () => {
    const response = await axios.get(`${API_BASE_URL}/health`);
    return response.data;
  },

  scanComplete: async (file: File) => {
    const formData = new FormData();
    formData.append('file', file);
    const response = await axios.post(`${API_BASE_URL}/scan/complete`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      timeout: 60000,
    });
    return response.data;
  },
};

export interface ScanResult {
  file: {
    name: string;
    size_bytes: number;
    sha256: string;
    entropy: number;
    possibly_packed: boolean;
  };
  cnn_verdict: {
    family: string;
    threat_level: string;
    confidence: number;
  };
  top3: Array<{
    family: string;
    confidence: number;
    threat_level: string;
  }>;
  virustotal: {
    found?: boolean;
    malicious?: number;
    total_engines?: number;
    detection_rate?: number;
    url?: string;
    error?: string;
  };
  yara: {
    rule_name: string;
    rule: string;
    valid: boolean;
    meta: {
      byte_signatures_extracted: number;
      required_matches: number;
    };
  };
}
